import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import Select from "react-select";

import { ApiUrl } from "../../../ApiUrl";

const SelectStudentModal = ({ show, handleClose, onSelectStudent }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [filters, setFilters] = useState({
    studentName: "",
    admissionNo: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });

  // Fetch Students Data
  useEffect(() => {
    const fetchFullStudentData = async () => {
      try {
        const academicSessionId = localStorage.getItem("academicSessionId");
        if (!academicSessionId) {
          console.error("No academic session ID found in local storage");
          return;
        }
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
        );
        if (!response.ok) {
          throw new Error("Error fetching student data");
        }
        const data = await response.json();
        if (data.data) {
          setFullStudentData(data.data);
          setStudentData(data.data);
        } else {
          console.warn("No data found for the given academic session ID");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchFullStudentData();
  }, []);

  // Fetch Classes and Sections
  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // const handleSearch = () => {
  //   const filteredData = fullStudentData.filter((student) => {
  //     const studentDetails = student.studentBasicDetails;
  //     const fullName = `${studentDetails.first_name} ${
  //       studentDetails.middle_name || ""
  //     } ${studentDetails.last_name}`
  //       .trim()
  //       .toLowerCase();
  //     const searchParts = filters.studentName
  //       .toLowerCase()
  //       .split(" ")
  //       .filter(Boolean);
  //     const nameMatches = searchParts.every((part) => fullName.includes(part));
  //     return (
  //       (!filters.studentName || nameMatches) &&
  //       (!filters.admissionNo ||
  //         studentDetails.school_admission_no
  //           .toString()
  //           .includes(filters.admissionNo)) &&
  //       (!filters.barcode ||
  //         studentDetails.barcode.toString().includes(filters.barcode)) &&
  //       (!filters.schoolAdmissionNo ||
  //         studentDetails.admission_no
  //           .toString()
  //           .includes(filters.schoolAdmissionNo)) &&
  //       (!filters.classId ||
  //         studentDetails.addmitted_class.toString() ===
  //           filters.classId.toString()) &&
  //       (!filters.section ||
  //         studentDetails.addmitted_section === filters.section) &&
  //       (!filters.fatherName ||
  //         studentDetails.father_name
  //           .toLowerCase()
  //           .includes(filters.fatherName.toLowerCase())) &&
  //       (!filters.motherName ||
  //         studentDetails.mother_name
  //           .toLowerCase()
  //           .includes(filters.motherName.toLowerCase()))
  //     );
  //   });
  //   setStudentData(filteredData);
  // };

  const handleSearch = () => {
    const filteredData = fullStudentData.filter((student) => {
      const studentDetails = student.studentBasicDetails;
      const fullName = `${studentDetails.first_name} ${studentDetails.middle_name || ""} ${studentDetails.last_name}`
        .trim()
        .toLowerCase();

      const searchParts = filters.studentName
        .toLowerCase()
        .split(" ")
        .filter(Boolean);

      const nameMatches = searchParts.every((part) => fullName.includes(part));

      return (
        (!filters.studentName || nameMatches) &&
        (!filters.admissionNo ||
          studentDetails.school_admission_no
            ?.toString()
            .includes(filters.admissionNo)) &&
        (!filters.barcode ||
          studentDetails.barcode?.toString().includes(filters.barcode)) &&
        (!filters.schoolAdmissionNo ||
          studentDetails.admission_no
            ?.toString()
            .includes(filters.schoolAdmissionNo)) &&
        (!filters.classId ||
          studentDetails.addmitted_class?.toString() ===
          filters.classId.toString()) &&
        (!filters.section ||
          studentDetails.addmitted_section?.toString() ===
          filters.section.toString()) &&
        (!filters.fatherName ||
          studentDetails.father_name
            ?.toLowerCase()
            .includes(filters.fatherName.toLowerCase())) &&
        (!filters.motherName ||
          studentDetails.mother_name
            ?.toLowerCase()
            .includes(filters.motherName.toLowerCase()))
      );
    });

    setStudentData(filteredData);
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  // const getSectionName = (sectionId) => {
  //   const sectionObj = sections.find((sec) => sec.id === sectionId);
  //   return sectionObj ? sectionObj.sectionname : "N/A";
  // };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.section_id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };

  const handleSelectStudent = (student) => {
    const studentId = student.studentBasicDetails.id;

    localStorage.setItem("selectedClubStudentId", studentId);

    onSelectStudent(student);

    // Close the modal after selection
    handleClose();
  };

  const handleClearFilters = () => {
    // Reset all filters and state variables
    setFilters({
      studentName: "",
      admissionNo: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass("");
    setSelectedSection("");
    setStudentData(fullStudentData);
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div className="col-12 d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Name{" "}
                      </label>
                      <input
                        type="text"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Admission No{" "}
                      </label>
                      <input
                        type="text"
                        name="admissionNo"
                        value={filters.admissionNo}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Admission No"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Barcode{" "}
                      </label>
                      <input
                        type="text"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Barcode"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }} // Inline style to set height and padding
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Class{" "}
                      </label>
                      {/* <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedClass(selectedOption?.value)
                        }
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                              label: getClassName(selectedClass),
                              value: selectedClass,
                            }
                            : null
                        }
                      /> */}
                      <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) => {
                          setSelectedClass(selectedOption?.value);
                          setFilters((prev) => ({
                            ...prev,
                            classId: selectedOption?.value || "",
                          }));
                        }}
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                              label: getClassName(selectedClass),
                              value: selectedClass,
                            }
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Section{" "}
                      </label>
                      {/* <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.id,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedSection(selectedOption?.value)
                        }
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                              label: getSectionName(selectedSection),
                              value: selectedSection,
                            }
                            : null
                        }
                      /> */}
                      <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.section_id,  // ✅ use section_id instead of id
                        }))}
                        onChange={(selectedOption) => {
                          setSelectedSection(selectedOption?.value);
                          setFilters((prev) => ({
                            ...prev,
                            section: selectedOption?.value || "",
                          }));
                        }}
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                              label: getSectionName(selectedSection),
                              value: selectedSection,
                            }
                            : null
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Father's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Father's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Mother's Name{" "}
                      </label>
                      <input
                        type="text"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Mother's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentData.map((student, index) => {
                          const studentDetails = student.studentBasicDetails;
                          const {
                            first_name,
                            middle_name,
                            last_name,
                            school_admission_no,
                            admission_no,
                            father_name,
                            mother_name,
                            barcode,
                            addmitted_class,
                            addmitted_section,
                          } = student.studentBasicDetails;
                          const fullName = `${first_name} ${middle_name} ${last_name}`;
                          return (
                            <tr key={index}>
                              <td>
                                {studentDetails.first_name}{" "}
                                {studentDetails.middle_name}{" "}
                                {studentDetails.last_name}
                              </td>
                              <td>{studentDetails.school_admission_no}</td>
                              <td>{studentDetails.admission_no}</td>
                              <td>
                                {getClassName(studentDetails.addmitted_class)}
                              </td>
                              <td>
                                {/* {getSectionName(
                                  studentDetails.addmitted_section
                                )} */}
                                {studentDetails.sectionname}
                              </td>
                              <td>{studentDetails.father_name}</td>
                              <td>{studentDetails.mother_name}</td>
                              <td>{studentDetails.barcode}</td>
                              <td>
                                <button
                                  className="btn btn-success"
                                  onClick={() => handleSelectStudent(student)}
                                >
                                  Select
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectStudentModal;
